import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ScrollToTop } from './components/shared/ScrollToTop'
import { SignInPage } from './modules/auth/SignInPage'
import { SignUpPage } from './modules/auth/SignUpPage'
import { ProtectedRoute } from './components/shared/ProtectedRoute'
import { DashboardLayout } from './layouts/DashboardLayout'
import { DashboardPage } from './pages/DashboardPage'
import { InsightsPage } from './modules/dashboard/pages/InsightsPage'
import { LandingPage } from './pages/LandingPage'
import { SettingsPage } from './modules/settings/pages/SettingsPage'
import { StoreSettingsPage } from './modules/store/pages/StoreSettingsPage'
import { SearchPreviewPage } from './modules/store/pages/SearchPreviewPage'
import { PlansPage } from './modules/plans/pages/PlansPage'
import { SynonymsPage } from './modules/synonyms/pages/SynonymsPage'
import RedirectsPage from './modules/redirects/pages/RedirectsPage'
import SearchandisingPage from './modules/searchandising/pages/SearchandisingPage'
import { StyleGuidePage } from './pages/StyleGuidePage'
import { ComponentsPage } from './pages/ComponentsPage'

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public landing page — self-contained, no PublicLayout wrapper
            (LandingPage provides its own header/footer with the CBS logo). */}
        <Route path="/" element={<LandingPage />} />

        {/* Auth routes (standalone, no layout) */}
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path="/sign-up" element={<SignUpPage />} />

        {/* Protected dashboard routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* Dashboard index page */}
          <Route index element={<DashboardPage />} />

          {/* Insights — popular queries, zero results, click stats */}
          <Route path="insights" element={<InsightsPage />} />

          {/* Settings module - profile, password, theme, etc. */}
          <Route path="settings" element={<SettingsPage />} />

          {/* Store settings - WooCommerce connection and widget config */}
          <Route path="store" element={<StoreSettingsPage />} />

          {/* Search Preview - showcase search capabilities */}
          <Route path="search-preview" element={<SearchPreviewPage />} />

          {/* Plans and pricing */}
          <Route path="plans" element={<PlansPage />} />

          {/* Synonyms management */}
          <Route path="synonyms" element={<SynonymsPage />} />

          {/* Redirects management */}
          <Route path="redirects" element={<RedirectsPage />} />

          {/* Searchandising rules */}
          <Route path="searchandising" element={<SearchandisingPage />} />

          {/* Profile redirects to Settings (Profile tab is default) */}
          <Route path="profile" element={<Navigate to="/dashboard/settings" replace />} />

          {/* Component showcase for development reference */}
          <Route path="components" element={<ComponentsPage />} />

          {/* Style guide for development */}
          <Route path="style-guide" element={<StyleGuidePage />} />
        </Route>

        {/* Catch all - redirect to landing page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
